import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IBeraterUebersicht} from '../shared/model/beraterUebersicht.model';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

type EntityArrayResponseType = HttpResponse<IBeraterUebersicht[]>;

@Injectable({providedIn: 'root'})
export class BeraterUebersichtService {
  public resourceUrl = environment.apiConfig.uri + 'api/berateruebersicht';

  constructor(protected http: HttpClient) {
  }

  query(
    searchwords?: string[],
    includeHidden?: boolean,
  ): Observable<EntityArrayResponseType> {
    const options = {};
    if (!!searchwords) {
      options['searchwords'] = searchwords;
    }
    if (!!includeHidden) {
      options['includeHidden'] = includeHidden;
    }
    return this.http.get<IBeraterUebersicht[]>(this.resourceUrl, {
      params: options,
      observe: 'response',
    });
  }
}
